export function queryParams(route, args) {
  let _args = { ...args };
  let url = route(_args);

  url += `?${new URLSearchParams(_args).toString()}`;

  return url;
}
